export const engagementAppGroupIdCanvasWorkflowIdContentOptimizationStepIdPerformanceContext =
  "/engagement/:app_group_id/canvas/:workflow_id/content_optimization/:step_id/performance_context";
